import UsernameSuggestions from "./UsernameSuggestions";

export default UsernameSuggestions;
